<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>
        Счётчик: {{ counter.serial_num }}({{ counter.model.name }}), ТУ: {{ counter.point_number }}
      </v-toolbar-title>
      <span
        v-if="taskInfo && taskInfo.status==='DONE'"
        class="last-update-info"
      >Последнее обновление было: {{ taskInfo.created_at | moment("DD/MM/YYYY HH:mm:ss") }}
      </span>
      <span
        v-if="taskInfo && taskInfo.status==='PENDING'"
        class="last-update-info"
      >Идёт сбор значений параметров, пожалуйста подождите <span v-if="taskInfo && taskInfo.details"> (получено {{ taskInfo.details }})</span>
      </span>
      <span
        v-if="taskInfo && taskInfo.status==='ERROR'"
        class="last-update-info"
      >Во время сбора параметров произошла ошибка, пожалуйста обратитесь к администратору
      </span>
      <v-spacer />
      <v-btn
        icon
        title="Закрыть"
        @click="close"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-tabs
      background-color="teal darken-3"
      dark
      show-arrows
    >
      <v-tab>
        Значения параметров счётчика
      </v-tab>
      <v-tab>
        Значения фаз
      </v-tab>
      <v-tab>
        Настройки
      </v-tab>
      <v-tab-item>
        <div
          v-if="Object.keys(counterInfo).length === 0"
          class="refresh-warn"
        >
          <v-card
            flat
            min-height="400"
          >
            <v-card-text>
              Параметры ещё не загружены, нажмите кнопку "Обновить"
              <v-btn
                icon
                title="Обновить показания"
                @click="refreshCounterInfoParameters"
              >
                <span class="refresh-icon"><v-icon>refresh</v-icon></span>
              </v-btn>
            </v-card-text>
          </v-card>
        </div>
        <v-tabs vertical>
          <v-tab
            v-for="(paramValues, paramName) in counterInfo"
            :key="paramName"
          >
            <span class="parameter-name">{{ paramName }}</span>
          </v-tab>
          <v-tab-item
            v-for="(paramValues, paramName) in counterInfo"
            :key="paramName"
          >
            <v-card flat>
              <v-card-text>
                <div
                  v-for="value in paramValues"
                  :key="value.name"
                >
                  <template v-if="value.value != null && value.value.indexOf('[') >= 0">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>{{ value.parameter_name }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div
                            v-for="(value, index) in test(value.value)"
                            :key="index"
                          >
                            {{ value }}
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </template>
                  <template v-else>
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        sm="8"
                      >
                        {{ value.parameter_name }}:
                      </v-col>
                      <template v-if="value.value != null">
                        <v-col
                          cols="12"
                          sm="2"
                          align="right"
                        >
                          <b>{{ value.value }}</b>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          align="right"
                        >
                          {{ value.measurement }}
                        </v-col>
                      </template>
                      <v-col
                        v-else
                        cols="12"
                        sm="4"
                        align="right"
                      >
                        <b>Данные не были получены</b>
                      </v-col>
                    </v-row>
                  </template>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
          min-height="400"
        >
          <v-card-title>Векторная диаграмма полной мощности</v-card-title>
          <v-card-text
            v-if="!phaseDataLoading && hasPhaseData"
            class="d-flex flex-row"
          >
            <v-data-table
              :headers="phaseDataHeaders"
              :items="phaseData"
              :items-per-page="50"
              hide-default-footer
              no-data-text="Нет данных для отображения"
              class="pa-2 phase-table"
              dense
            />
            <span class="pa-6">
              <svg
                width="400"
                height="280"
              >
                <line
                  stroke-width="15"
                  x1="30"
                  y1="30"
                  x2="15"
                  y2="30"
                  stroke="orange"
                />
                <text
                  x="40"
                  y="35"
                  class="small"
                >Фаза A</text>
                <line
                  stroke-width="15"
                  x1="30"
                  y1="50"
                  x2="15"
                  y2="50"
                  stroke="green"
                />
                <text
                  x="40"
                  y="55"
                  class="small"
                >Фаза B</text>
                <line
                  stroke-width="15"
                  x1="30"
                  y1="70"
                  x2="15"
                  y2="70"
                  stroke="blue"
                />
                <text
                  x="40"
                  y="75"
                  class="small"
                >Фаза C</text>
                <defs>
                  <marker
                    id="arrow_orange"
                    viewBox="0 0 20 20"
                    refX="5"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto-start-reverse"
                  >
                    <path
                      d="M 0 0 L 10 5 L 0 10 z"
                      fill="orange"
                    />
                  </marker>
                  <marker
                    id="arrow_green"
                    viewBox="0 0 20 20"
                    refX="5"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto-start-reverse"
                  >
                    <path
                      d="M 0 0 L 10 5 L 0 10 z"
                      fill="green"
                    />
                  </marker>
                  <marker
                    id="arrow_blue"
                    viewBox="0 0 20 20"
                    refX="5"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto-start-reverse"
                  >
                    <path
                      d="M 0 0 L 10 5 L 0 10 z"
                      fill="blue"
                    />
                  </marker>
                  <marker
                    id="arrow_black"
                    viewBox="0 0 20 20"
                    refX="5"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto-start-reverse"
                  >
                    <path
                      d="M 0 0 L 10 5 L 0 10 z"
                      fill="black"
                    />
                  </marker>
                </defs>
                <text
                  x="335"
                  y="142"
                  class="small"
                >90&#176;</text>
                <text
                  x="200"
                  y="275"
                  class="small"
                >180&#176;</text>
                <text
                  x="55"
                  y="145"
                  class="small"
                >270&#176;</text>
                <text
                  x="205"
                  y="15"
                  class="small"
                >0&#176;</text>
                <circle
                  stroke-width="2"
                  stroke="black"
                  cx="210"
                  cy="140"
                  r="120"
                  style="fill: white;"
                />
                <line
                  stroke-width="1"
                  x1="90"
                  y1="140"
                  x2="330"
                  y2="140"
                  stroke="black"
                />
                <line
                  stroke-width="1"
                  x1="210"
                  y1="20"
                  x2="210"
                  y2="260"
                  stroke="black"
                />
                <text
                  x="290"
                  y="15"
                  class="heavy"
                >I</text>
                <line
                  stroke-width="3"
                  x1="290"
                  y1="20"
                  x2="330"
                  y2="20"
                  stroke="black"
                  marker-end="url(#arrow_black)"
                />
                <text
                  x="290"
                  y="40"
                  class="heavy"
                >U</text>
                <line
                  stroke-width="3"
                  x1="290"
                  y1="45"
                  x2="380"
                  y2="45"
                  stroke="black"
                  marker-end="url(#arrow_black)"
                />
                <g
                  v-if="showLines"
                  class="phase-line"
                >
                  <path
                    class="phase-one"
                    :d="'M210 ' + uOne + 'V140'"
                    marker-start="url(#arrow_orange)"
                  />
                </g>
                <g
                  v-if="showLines"
                  class="phase-line"
                  :style="{ transform: 'rotate(' + angAdditionalOne + 'deg)' }"
                >
                  <path
                    class="phase-one"
                    :d="'M210 ' + iOne + 'V140'"
                    marker-start="url(#arrow_orange)"
                  />
                </g>
                <g
                  v-if="showLines"
                  class="phase-line"
                  :style="{ transform: 'rotate(' + angTwo + 'deg)' }"
                >
                  <path
                    class="phase-two"
                    :d="'M210 ' + uTwo + 'V140'"
                    marker-start="url(#arrow_green)"
                  />
                </g>
                <g
                  v-if="showLines"
                  class="phase-line"
                  :style="{ transform: 'rotate(' + angAdditionalTwo + 'deg)' }"
                >
                  <path
                    class="phase-two"
                    :d="'M210 ' + iTwo + 'V140'"
                    marker-start="url(#arrow_green)"
                  />
                </g>
                <g
                  v-if="showLines"
                  class="phase-line"
                  :style="{ transform: 'rotate(' + angThree + 'deg)' }"
                >
                  <path
                    class="phase-three"
                    :d="'M210 ' + uThree + 'V140'"
                    marker-start="url(#arrow_blue)"
                  />
                </g>
                <g
                  v-if="showLines"
                  class="phase-line"
                  :style="{ transform: 'rotate(' + angAdditionalThree + 'deg)' }"
                >
                  <path
                    class="phase-three"
                    :d="'M210 ' + iThree + 'V140'"
                    marker-start="url(#arrow_blue)"
                  />
                </g>
              </svg>
            </span>
          </v-card-text>
          <v-card-text
            v-if="!phaseDataLoading && !hasPhaseData"
            class="d-flex flex-row"
          >
            Нет данных по фазам счётчика.
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
          min-height="400"
        >
          <v-card-text>
            <v-expansion-panels
              v-model="panel"
              multiple
            >
              <v-expansion-panel
                v-for="(params, groupName) in counterSelectedParams"
                :key="groupName"
              >
                <v-expansion-panel-header>{{ groupName }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-checkbox
                    v-for="parameter in params"
                    :key="parameter.parameter_id"
                    v-model="parameter.is_selected"
                    :label="parameter.parameter_name"
                    hide-details
                    @change="updateParameter(parameter)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-spacer />
      <span class="pt-1 pr-4">
        <v-btn
          icon
          title="Обновить показания"
          @click="refreshCounterInfoParameters"
        >
          <span class="refresh-icon-white"><v-icon>refresh</v-icon></span>
        </v-btn>
      </span>
    </v-tabs>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CounterParameters',
  props: {
    counterId: {},
    isOpen: {}
  },
  data () {
    return {
      counter: {
        point_number: '',
        serial_num: '',
        model: { name: '' }
      },
      counterInfo: {},
      taskInfo: {},
      needToRefreshStatusInfo: true,
      counterSelectedParams: [],
      panel: [],
      phaseDataHeaders: [
        {
          text: 'Наименование',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Фаза A',
          align: 'center',
          sortable: false,
          value: 'v1'
        },
        {
          text: 'Фаза B',
          align: 'center',
          sortable: false,
          value: 'v2'
        },
        {
          text: 'Фаза C',
          align: 'center',
          sortable: false,
          value: 'v3'
        },
        {
          text: 'Сумма',
          align: 'center',
          sortable: false,
          value: 'v4'
        },
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'measure'
        }
      ],
      phaseData: [],
      additionalAng: 15,
      uOne: 0,
      iOne: 0,
      uTwo: 0,
      iTwo: 0,
      angTwo: 0,
      angAdditionalOne: 0,
      angAdditionalTwo: 0,
      uThree: 0,
      iThree: 0,
      angThree: 0,
      angAdditionalThree: 0,
      showLines: false,
      phaseDataLoading: true,
      hasPhaseData: false
    }
  },
  watch: {
    counterId: {
      handler () {
        if (this.counterId === undefined) {}
      },
      immediate: true
    },
    isOpen: {
      handler (val) {
        this.needToRefreshStatusInfo = val
        if (val) {
          this.getCounterInfo()
          this.getCounterParametersToCollect()
        } else {
          this.counterInfo = {}
          this.taskInfo = {}
        }
      },
      immediate: true
    }
  },
  methods: {
    getCounterPhaseData () {
      axios.get(`/api/counters/${this.counterId}/phase/`)
        .then((response) => {
          this.hasPhaseData = response.data.values_date != null
          this.phaseData = response.data.values
          var u1 = parseFloat(this.phaseData[4].v1)
          var u2 = parseFloat(this.phaseData[4].v2)
          var u3 = parseFloat(this.phaseData[4].v3)
          var i1 = parseFloat(this.phaseData[5].v1)
          var i2 = parseFloat(this.phaseData[5].v2)
          var i3 = parseFloat(this.phaseData[5].v3)
          this.angTwo = parseFloat(this.phaseData[6].v4)
          this.angThree = parseFloat(this.phaseData[6].v4) + parseFloat(this.phaseData[8].v4)

          var angAddOne = this.phaseData[9].v4 !== '' ? parseFloat(parseFloat(this.phaseData[9].v4)) : this.additionalAng
          var angAddTwo = this.phaseData[10].v4 !== '' ? parseFloat(parseFloat(this.phaseData[10].v4)) : this.additionalAng
          var angAddThree = this.phaseData[11].v4 !== '' ? parseFloat(parseFloat(this.phaseData[11].v4)) : this.additionalAng

          var uMax = Math.max(u1, u2, u3, 0.001)
          var iMax = Math.max(i1, i2, i3, 0.001)
          var lineLen = 140
          var shortLineLen = 70
          var maxLineLen = 165
          this.uOne = maxLineLen - (lineLen / uMax) * u1
          this.iOne = lineLen - shortLineLen / iMax * i1
          this.uTwo = maxLineLen - (lineLen / uMax) * u2
          this.iTwo = lineLen - shortLineLen / iMax * i2
          this.uThree = maxLineLen - (lineLen / uMax) * u3
          this.iThree = lineLen - shortLineLen / iMax * i3
          this.angAdditionalOne = angAddOne
          this.angAdditionalTwo = this.angTwo + angAddTwo
          this.angAdditionalThree = this.angThree + angAddThree
          this.showLines = true
          this.phaseDataLoading = false
        }).catch((err) => {
          console.log(err)
          this.phaseDataLoading = false
        })
    },
    getCounterInfoParameters () {
      axios.get(`/api/counter/${this.counterId}/get_current_data/`)
        .then((response) => {
          this.counterInfo = response.data.data
          this.taskInfo = response.data.task
          this.getCounterPhaseData()
          if (this.taskInfo && this.taskInfo.status === 'PENDING') {
            if (this.needToRefreshStatusInfo) {
              setTimeout(() => {
                this.getCounterInfoParameters()
              }, 1000)
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    refreshCounterInfoParameters () {
      if (confirm('Вы уверены что хотите обновить инфрмацию по последним значениям параметров счётчика?')) {
        axios.get(`/api/counter/${this.counterId}/get_current_data/?refresh=1`)
          .then(() => {
            this.getCounterInfoParameters()
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    getCounterInfo () {
      axios.get(`/api/counters/${this.counterId}/`)
        .then((response) => {
          this.counter = response.data
          this.getCounterInfoParameters()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCounterParametersToCollect () {
      axios.get(`/api/counters_parameters_to_collect/all_parameters_by_counter/?counter_id=${this.counterId}`)
        .then((response) => {
          this.counterSelectedParams = response.data.reduce(function (map, obj) {
            let groupName = obj.parameter_group
            if (groupName === '') {
              groupName = 'Параметры без группы'
            }
            if (!map[groupName]) {
              map[groupName] = []
            }
            map[groupName].push(obj)
            return map
          }, {})
        })
        .catch((err) => {
          console.log(err)
        })
    },
    close () {
      this.$emit('close')
      this.counterInfo = {}
      this.needToRefreshStatusInfo = false
    },
    updateParameter (param) {
      if (param.is_selected) {
        axios.post(`/api/counters_parameters_to_collect/`, {
          counter_id: this.counterId,
          parameter_id: param.parameter_id
        })
          .catch((err) => {
            console.log(err)
          })
      } else {
        axios.post(`/api/counters_parameters_to_collect/unselect/`, {
          counter_id: this.counterId,
          parameter_id: param.parameter_id
        })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    test (value) {
      let result
      try {
        result = JSON.parse(value.replace(/'/g, '"'))
      } catch (e) {
        result = [value]
      }
      return result
    }
  }
}
</script>

<style lang="scss">
  .parameter-name {
    width: 320px;
    text-align: left;
  }
  .last-update-info {
    position: absolute;
    top: 45px;
    font-size: 12px;
  }
  .refresh-icon .v-icon{
    color: #f32e2e !important;
  }
  .refresh-icon-white .v-icon{
    color: #ffffff !important;
  }
  .refresh-warn {
    min-height: 500px;
  }
  .small {
    font: italic 15px sans-serif;
  }
  .heavy {
    font: bold 18px sans-serif;
  }
  .phase-one {
    fill: none;
    stroke: orange;
    stroke-width: 3;
    stroke-miterlimit: 10;
  }
  .phase-two {
    fill: none;
    stroke: green;
    stroke-width: 3;
    stroke-miterlimit: 10;
  }
  .phase-three {
    fill: none;
    stroke: blue;
    stroke-width: 3;
    stroke-miterlimit: 10;
  }

  .phase-line {
    transform-origin: 210px 140px;
  }
</style>



// WEBPACK FOOTER //
// src/spa/counters/CounterParametersData.vue